import { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';

export const AONOnboardTask = ({
  name,
  onboarded,
  description,
  completed,
  enabled = true,
  onClick
}) => {
  const [hover, setHover] = useState(false);

  // Pre-onboarding
  if (!enabled || !onboarded) {
    return !completed ? (
      <div
        className="aon-menu-option-inactive"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={event => {
          if (enabled) onClick();
        }}
        style={hover ? { cursor: 'pointer' } : {}}
      >
        {icon ? (
          <img
            className="aon-menu-option-active-bold"
            src={icon}
            alt="task icon"
            style={{ opacity: enabled ? 0.5 : 0.3 }}
          />
        ) : null}
        <div
          className={
            enabled
              ? 'aon-menu-option-inactive-text'
              : 'aon-menu-option-disabled-text'
          }
        >
          {name}
          {description && (
            <span className="aon-menu-option-active-subtext">
              {icon ? '' : ': '}
              {description}
            </span>
          )}
        </div>
        <div>
          <img
            className="aon-menu-option-inactive-chevron"
            src={
              enabled
                ? '/images/aon/chevron-right.svg'
                : '/images/aon/chevron-right-disabled.svg'
            }
            alt="menuoption"
          />
        </div>
      </div>
    ) : (
      <div
        className="aon-menu-option-active"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={event => onClick()}
        style={hover ? { cursor: 'pointer' } : {}}
      >
        <img
          className="aon-menu-option-active-bold"
          src="/images/aon/check-circle-bold.svg"
          alt="menuoption"
        />
        <div className="aon-menu-option-active-text">
          {name}
          <span className="aon-menu-option-active-subtext">
            {description ? `: ${description}` : ''}
          </span>
        </div>
      </div>
    );
    // Post-onboarding additional requirements
  } else {
    return (
      <div
        className="aon-menu-option-active"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={event => onClick()}
        style={hover ? { cursor: 'pointer' } : {}}
      >
        <img
          className="aon-menu-option-active-bold"
          src={
            completed
              ? '/images/aon/circle-green.svg'
              : '/images/aon/circle-red.svg'
          }
          alt="menuoption"
        />
        <div className="aon-menu-option-active-text">
          {name}
          <span className="aon-menu-option-active-subtext">
            {description ? `: ${description}` : ''}
          </span>
        </div>
      </div>
    );
  }
};

export const AONTimeRange = ({
  name,
  options,
  lowValue,
  setLowValue,
  highValue,
  setHighValue
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="aon-flex-box" style={{ overflow: 'initial' }}>
        <span className="aon-flex-box-left-right aon-text-box-span-light">
          {name}
        </span>
        <span className="aon-flex-box-middle"></span>
        <span
          className="aon-flex-box-left-right"
          style={{ overflow: 'initial' }}
        >
          <Dropdown
            compact
            selection
            options={options}
            onChange={(e, inputProps) => setLowValue(inputProps.value)}
            value={lowValue}
            upward={false}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
          />
          {' - '}
          <Dropdown
            compact
            selection
            options={options}
            onChange={(e, inputProps) => setHighValue(inputProps.value)}
            value={highValue}
            upward={false}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
          />
        </span>
      </div>
      {/* HACK for Semantic UI bug displaying elements in front of dropdown */}
      {open ? (
        <>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </>
      ) : (
        ''
      )}
    </>
  );
};

export const AONTimeRange2 = ({
  name,
  options,
  lowValue,
  setLowValue,
  highValue,
  setHighValue
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="aon-flex-box" style={{ overflow: 'initial' }}>
        <span className="aon-flex-box-left-right aon-text-box-span-light">
          {name}
        </span>
        <span className="aon-flex-box-middle"></span>
        <span
          className="aon-flex-box-left-right"
          style={{ overflow: 'initial' }}
        >
          <Dropdown
            compact
            selection
            options={options}
            onChange={(e, inputProps) => setLowValue(inputProps.value)}
            value={lowValue}
            upward={false}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
          />
          {' - '}
          <Dropdown
            compact
            selection
            options={options}
            onChange={(e, inputProps) => setHighValue(inputProps.value)}
            value={highValue}
            upward={false}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
          />
        </span>
      </div>
      {/* HACK for Semantic UI bug displaying elements in front of dropdown */}
      {open ? (
        <>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </>
      ) : (
        ''
      )}
    </>
  );
};

export const AONLink = ({ text, onClick }) => {
  const [hover, setHover] = useState(false);

  return (
    <span
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      style={hover ? { cursor: 'pointer' } : {}}
    >
      <b>
        <u>{text}</u>
      </b>
    </span>
  );
};

export const AONButton = ({ active, buttonText, onClick }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="aon-button"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        ...(hover
          ? {
              cursor: 'pointer',
              backgroundImage: active
                ? 'url("/images/aon/button-background-hover.svg")'
                : 'url("/images/aon/button-grey-background.svg")'
            }
          : {
              backgroundImage: active
                ? 'url("/images/aon/button-background.svg")'
                : 'url("/images/aon/button-grey-background.svg")'
            })
      }}
      onClick={() => {
        if (active) onClick();
      }}
    >
      {active ? (
        <div className="aon-button-text">{buttonText}</div>
      ) : (
        <div className="aon-button-grey">{buttonText}</div>
      )}
    </div>
  );
};

export const AONCheckBox = ({ text, selected, toggleSelection }) => {
  return (
    <div onClick={() => toggleSelection()}>
      <span className="aon-text-box-span-bold2">{text}</span>
      <img
        style={{ position: 'relative', top: '6px', left: '10px' }}
        src={
          selected
            ? '/images/aon/checkbox-selected.svg'
            : '/images/aon/checkbox.svg'
        }
        alt="checkbox"
      />
    </div>
  );
};

export const AONRadioButtons = ({ options, selected, setSelected }) => {
  return options.map((o, idx) => (
    <div
      className="aon-frame5"
      onClick={() => {
        if (o.enabled) setSelected(o.value);
      }}
    >
      <div className="aon-flex-box2">
        <span className="aon-flex-box2-left-right">
          <span className="aon-text-box-span-bold">{o.name}</span>
          <span className="aon-text-box-span-light">
            {o.desc ? ' - ' + o.desc : ' .'}
          </span>
        </span>
        <span className="aon-flex-box2-middle"></span>
        <span className="aon-flex-box2-left-right">
          {o.enabled ? (
            <img
              src={
                o.value === selected
                  ? '/images/aon/checkbox-selected.svg'
                  : '/images/aon/checkbox.svg'
              }
              alt="radiobutton"
            />
          ) : (
            ''
          )}
        </span>
      </div>
    </div>
  ));
};

export const AONNav = ({ onClick }) => {
  const [hover, setHover] = useState(false);

  return (
    <img
      src="/images/aon/chevron-left.svg"
      alt="back"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      style={hover ? { cursor: 'pointer' } : {}}
    />
  );
};

export const AONNavSteps = ({ step, numSteps, onPrev, onNext }) => {
  const [hover, setHover] = useState(false);

  return (
    <>
      <div style={{ width: '500px' }}>
        <div style={{ float: 'left', width: '20px' }}>
          <img
            className="aon-nav-chevron"
            src="/images/aon/chevron-left.svg"
            alt="menuoption"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={event => onPrev()}
            style={hover ? { cursor: 'pointer' } : {}}
          />
        </div>
        <div style={{ float: 'left', width: '20px' }}>
          <img
            className="aon-nav-chevron"
            src="/images/aon/chevron-right.svg"
            alt="menuoption"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={event => onNext()}
            style={hover ? { cursor: 'pointer' } : {}}
          />
        </div>
        <div style={{ float: 'left', width: '80px' }}>
          <span className="aon-nav-steps">
            {step} of {numSteps}
          </span>
        </div>
        <br style={{ clear: 'left' }} />
      </div>
      <br />
    </>
  );
};
